export const Services = {
   "GET_DASHBOARD_SERVICE": {
      "path": "https://rrapidashboard.azurewebsites.net/",
      "method": "POST",
      "descrp": "service dashboard"
   },
   "GET_DASHBOARD_CATYEARS": {
      "path": "https://rrapidashboard.azurewebsites.net/",
      "method": "POST",
      "descrp": "data year graphic"
   },
   "GET_DASHBOARD_TOPERACIONES": {
      "path": "https://rrapidashboard.azurewebsites.net/",
      "method": "POST",
      "descrp": "data graphics"
   }
}